import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Mission Shakti</h1>
                <p>Home &gt; Mission Shakti</p>
            </div>
        </div>
    )
}

export default Hero;